import { useMutation } from '@tanstack/react-query';
import masterServicesAPI from '../../../../../../apis/master-services';

export const useDeleteService = () => {
  const { mutate: deleteMasterService, isSuccess } = useMutation((serviceId: string) =>
    masterServicesAPI.deleteMasterService(serviceId)
  );

  return { deleteMasterService, isSuccess };
};
